import { Logger, LogManager } from "@mcleod/core";
import { KeyHandler } from "./KeyHandler";
import { KeyHandlerGroup } from "./KeyHandlerGroup";
import { KeyListener } from "../events/KeyEvent";

/**
 * This class provides access to add/remove a global key handler (that is not tied to a component).
 */
export class GlobalKeyHandlerGroup {
    private static readonly group = new KeyHandlerGroup();
    private static _log: Logger;

    public static get(): KeyHandlerGroup {
        return this.group;
    }

    public static add(keyHandler: KeyHandler) {
        if (keyHandler.key == null) {
            keyHandler.key = "ALL";
        }
        this.getLog().debug("Adding global key handler: %o", keyHandler);
        this.group.addKeyHandler(keyHandler);
    }

    public static remove(listener: KeyListener) {
        this.getLog().debug("Removing global key handler: %o", listener);
        this.group.removeKeyHandler(listener);
    }

    public static clear() {
        this.getLog().debug("Clearing global key handlers");
        this.group.clear();
    }

    private static getLog(): Logger {
        if (this._log == null) {
            this._log = LogManager.getLogger("components.keyhandling.GlobalKeyHandlerGroup");
        }
        return this._log;
    }
}
